import { createContext, useContext } from "react";

import { useRichText } from "./useRichText";

export type RichTextContextValues = ReturnType<typeof useRichText>;

export const RichTextContext = createContext<RichTextContextValues | null>(null);

export const useRichTextContext = () => {
  const value = useContext(RichTextContext);

  if (!value) {
    throw new Error("useRichTextContext used outside of RichTextContext");
  }

  return value;
};

export const TopDescriptionRichTextContext = createContext<RichTextContextValues | null>(null);

export const useTopDescriptionRichTextContext = () => {
  const value = useContext(TopDescriptionRichTextContext);

  if (!value) {
    throw new Error(
      "useTopDescriptionRichTextContext used outside of TopDescriptionRichTextContext",
    );
  }

  return value;
};

export const ExtendedDescriptionRichTextContext = createContext<RichTextContextValues | null>(
  null,
);

export const useExtendedDescriptionRichTextContext = () => {
  const value = useContext(ExtendedDescriptionRichTextContext);

  if (!value) {
    throw new Error(
      "useExtendedDescriptionRichTextContext used outside of ExtendedDescriptionRichTextContext",
    );
  }

  return value;
};
